import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loader", "icons", "typography", "palette", "breakpoints", "borderRadius", "toastAnimation", "toastPosition", "zIndex", "skeletonAnimations", "translate", "blockchainLinks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { defaultTheme } from "./defaultTheme";
import { deepmerge } from "@peersyst/react-utils";
import { createBreakpoints } from "./createBreakpoints";
export function createTheme(_ref) {
  var loader = _ref.loader,
      icons = _ref.icons,
      typography = _ref.typography,
      palette = _ref.palette,
      breakpoints = _ref.breakpoints,
      borderRadius = _ref.borderRadius,
      toastAnimation = _ref.toastAnimation,
      toastPosition = _ref.toastPosition,
      zIndex = _ref.zIndex,
      skeletonAnimations = _ref.skeletonAnimations,
      translate = _ref.translate,
      blockchainLinks = _ref.blockchainLinks,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread({
    loader: loader || defaultTheme.loader,
    icons: _objectSpread(_objectSpread({}, defaultTheme.icons), icons),
    typography: deepmerge(defaultTheme.typography, typography),
    palette: deepmerge(defaultTheme.palette, palette),
    shadows: defaultTheme.shadows,
    breakpoints: createBreakpoints(_objectSpread(_objectSpread({}, defaultTheme.breakpoints.values), breakpoints == null ? void 0 : breakpoints.values)),
    borderRadius: borderRadius || defaultTheme.borderRadius,
    toastAnimation: toastAnimation || defaultTheme.toastAnimation,
    toastPosition: toastPosition || defaultTheme.toastPosition,
    zIndex: _objectSpread(_objectSpread({}, defaultTheme.zIndex), zIndex),
    skeletonAnimations: skeletonAnimations || defaultTheme.skeletonAnimations,
    translate: translate || defaultTheme.translate,
    blockchainLinks: _objectSpread(_objectSpread({}, defaultTheme.blockchainLinks), blockchainLinks)
  }, rest);
}